import {
  PRIMARY_BUTTON_CLICKED_MODAL_EVENT,
  CLOSE_BUTTON_CLICKED_MODAL_EVENT,
  SECONDARY_BUTTON_CLICKED_MODAL_EVENT,
} from "@/components/modal/events";
import ModalAlert from "@/components/modal/ModalAlert";
import VueModal from "@/components/modal/VueModal.vue";

export {
  PRIMARY_BUTTON_CLICKED_MODAL_EVENT,
  CLOSE_BUTTON_CLICKED_MODAL_EVENT,
  SECONDARY_BUTTON_CLICKED_MODAL_EVENT,
  ModalAlert,
  VueModal as default,
};
